// extracted by mini-css-extract-plugin
module.exports = {"teaserFirst":"small-with-medium_teaserFirst__LOKpd"};